import isPwa from '@/helper/isPwa';

export default function ({route}) {
  const meta = {};
  if (isPwa !== undefined) {
    meta.isPwa = ['setCustomVariable', 1, 'isPwa', isPwa];
  }
  route.meta.matomo = meta;
}
